<template>
  <v-sheet tile class="fill-height" align="top">
    <v-container>
      <v-container>
        <div v-for="i in 8" :key="i">
          <img width="100%" :src="'static/PrivacyPolicy/SpotSaver_privacy_policy-' + i + '.png'"/>
        </div>
      </v-container>
    </v-container>
  </v-sheet>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "PrivacyPage",
    computed: {
      ...mapGetters(['isVisitor', 'isSecurity', 'isStoreManager', 'isBrandManager', 'isSuperAdmin', 'userIsAuthenticated'])
    },
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/Pages/PrivacyPage.vue